import Carousel from 'react-bootstrap/Carousel';
import { useState } from 'react';
import AntheTripWinner from '../../assets/anthe-winner-trip.png';

const TripWinner = () => {
    const [imgCount, setImgCount] = useState(1);
    const [index, setIndex] = useState(0);
    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <div className='mb-5 mt-4 tripwinner'>
        <Carousel activeIndex={index} onSelect={handleSelect}>
            {new Array(imgCount).fill(1).map((v, i) => {
                return(
                <Carousel.Item key={i}>
                    <div className="carousel-indicators"><button type="button" data-bs-target="" aria-label="Slide 1" className="active" aria-current="true"></button><button type="button" data-bs-target="" aria-label="Slide 2" aria-current="false"></button></div>
                    {/* <img src={`https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/${stream}-desktop-${i+1}.png`} className="img-fluid d-sm-block d-none" alt="trip-winner-desktop"/>
                    <img src={`https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/dashboard/result/${stream}-mobile-${i+1}.png`} className="img-fluid d-block d-sm-none img_mobile" alt="trip-winners-mob"/> */}
                    <img src = {AntheTripWinner} alt='tripwinner-images' className='img-fluid'/>
                </Carousel.Item>
                
            )})}
        </Carousel>
        </div>
    );

}
export default TripWinner;